export const enum ChallengeProgressStatusEnum {
  COMPLETED = 'completed',
  GRADING_IN_PROGRESS = 'grading in progress',
  OPEN = 'open',
  OPEN_TRY_AGAIN = 'open - please try again',
};
